import Vue from 'vue';
import { HTTP } from '../../../../utils/httpCommonUtil';
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner';
import { getRestParamErrorMessage, getRestResponseErrorMessage } from '@/utils/serverErrorMessageUtil';
import flatPickr from 'vue-flatpickr-component';
import format from 'date-fns/format';
import { UserRoleEnum } from '@/enums/userRolesEnum';
import GenericModal from '@/componentsReusable/genericModal.vue';
import facilityEventHub from '@/components/facility/FacilityEventHub';

export default Vue.component('facility-specialty-notes-card', {
  name: 'FacilitySpecialtyNotesCard',
  data () {
    let emptyArray: Array<any> = [];
    return {
      cardExpanded: false,
      loadingInitialData: false,
      savingNewFacilitySpecialtyNote: false,
      facilitySpecialtyNotes: emptyArray,
      isAuthorizedToDelete: false,
      showConfirmationModal: false,
      pendingDeleteFacilityNote: null,
      noteErrorMessage: ''
    }
  },
  components: {
    flatPickr,
    BallPulseLoader,
    VueSimpleSpinner,
    GenericModal
  },
  created: function () {
    facilityEventHub.$on('SPECIALTY_CHANGE', this.specialtyChangeEvent)
  },
  beforeDestroy: function () {
    facilityEventHub.$off('SPECIALTY_CHANGE', this.specialtyChangeEvent)
  },
  beforeMount: function () {
    this.isAuthorizedToDelete = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]);
  },
  filters: {
    dateformat (dateISO: string) {
      let tempString: string = format(dateISO, 'M.D.YY - HH:mm');
      return tempString;
    }
  },
  methods: {
    specialtyChangeEvent () {
      setTimeout( () => {
        this.getFacilitySpecialtyNotes()
      },0);
    },
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getFacilitySpecialtyNotes()
      }
    },
    getFacilitySpecialtyNotes () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      let facilityId = this.$route.params.facilityId;
      let specialtyId = this.$route.params.specialtyId;
      HTTP.get('/api/facilities/' + facilityId + '/specialties/' + specialtyId + '/facilitySpecialtyNotes')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving Facility-Specialty Notes.");
        }
        let freshFacilitySpecialtyNotes = response.data.data;
        freshFacilitySpecialtyNotes.forEach( function (facilitySpecialtyNote: any) {
          facilitySpecialtyNote.isEditing = false;
          // facilitySpecialtyNote.isViewing = false;
          facilitySpecialtyNote.isNew = false;
          facilitySpecialtyNote.updatingData = false;
          facilitySpecialtyNote.note = facilitySpecialtyNote.note.trim();
        });

        self.facilitySpecialtyNotes = freshFacilitySpecialtyNotes;
      })
      .catch(function () {
        console.log('response Error!');
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Facility-Specialty Notes.'
        });
      })
    },
    saveFacilitySpecialtyNote (newFacilitySpecialtyNote: any) {
      let self = this
      const entityType = 12; // This is found in the DB. In this case this type means "FACILITY_SPECIALTY_NOTE"
      self.savingNewFacilitySpecialtyNote = true;
      HTTP.post('/api/facilitySpecialtyNote/', {
        "entityId": this.$route.params.facilityId,
        "entityId2": this.$route.params.specialtyId,
        "entityType": entityType,
        "note": newFacilitySpecialtyNote.note
      })
      .then(function (response) {
        self.savingNewFacilitySpecialtyNote = false;
        newFacilitySpecialtyNote.isEditing = false;
        self.getFacilitySpecialtyNotes();
      })
      .catch(function (err) {
        self.savingNewFacilitySpecialtyNote = false;
        self.noteErrorMessage = getRestParamErrorMessage(err, 'note');

        if (!self.noteErrorMessage ) {
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error',
            text: 'An error occurred saving facility-specialty note.'
          });
        }

      })
    },
    addFacilitySpecialtyNote () {
      // Collapse any editing facility notes
      // Delete any existing "new" facility notes
      let indexesToDelete: any = [];
      this.facilitySpecialtyNotes.forEach(function (note, index) {
        if (note.isNew) {
          indexesToDelete.push(index);
        }
        note.isAdding = false;
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.facilitySpecialtyNotes.splice(indx,1);
      })

      // let expirationDate = new Date();
      // expirationDate.setFullYear(expirationDate.getFullYear() + 1);
      this.facilitySpecialtyNotes.unshift(
        {
          "facilityId": this.$route.params.facilityId,
          "createdOn": new Date(),
          "note": "",
          "isNew": true,
          "isViewing": false,
          "isEditing": true
        }
      );
      setTimeout(function () {
        document.getElementById('taFacilitySpecialtyNote')!.focus();
      }, 1000);
    },
    deleteConfirmed (deleteFacilitySpecialtyNote: any) {
      this.showConfirmationModal = false;
      this.deleteFacilitySpecialtyNote((this as any).pendingDeleteFacilitySpecialtyNote, true);
    },
    deleteFacilitySpecialtyNote (deleteFacilitySpecialtyNote: any, bypassDeleteConfirmation: boolean = false) {
      // To prevent a double submit
      if (deleteFacilitySpecialtyNote.updatingData) { console.log("returning."); return ; }

      if (!bypassDeleteConfirmation) {
        // Show Delete Confirmation Modal
        this.showConfirmationModal = true;
        (this as any).pendingDeleteFacilitySpecialtyNote = deleteFacilitySpecialtyNote;
        return;
      } else {
        (this as any).pendingDeleteFacilitySpecialtyNote = null;
      }

      console.log("not returning.");
      let self = this
      deleteFacilitySpecialtyNote.updatingData = true;
      HTTP.delete('/api/facilities/' + this.$route.params.facilityId + '/facilitySpecialtyNotes/' + deleteFacilitySpecialtyNote.facilitySpecialtyNoteId)
      .then(function (response) {
        deleteFacilitySpecialtyNote.updatingData = false;
        deleteFacilitySpecialtyNote.isEditing = false;
        deleteFacilitySpecialtyNote.isViewing = false;
        self.getFacilitySpecialtyNotes();
      })
      .catch(function (error) {
        deleteFacilitySpecialtyNote.updatingData = false;

        deleteFacilitySpecialtyNote.facilityNoteIdErrorMessage = getRestParamErrorMessage(error, 'facilitySpecialtyNoteId');
        deleteFacilitySpecialtyNote.createdOnErrorMessage = getRestParamErrorMessage(error, 'createdOn');
        // deleteFacilitySpecialtyNote.noteErrorMessage = getRestParamErrorMessage(error, 'note');

        if (
          !deleteFacilitySpecialtyNote.facilityIdErrorMessage.length &&
          !deleteFacilitySpecialtyNote.issuedDateErrorMessage.length ) {
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Deleting',
            text: generalError ? generalError : 'An error occurred deleting facility-specialty note.',
            // duration: 5000
          });
        }

      })
    },
    toggleViewFacilitySpecialtyNote (facilitySpecialtyNote: any) {
      let selectedFacilitySpecialtyNoteId = facilitySpecialtyNote.noteId;
      // Collapse any editing facility-specialty notes
      // Delete any existing "new" facility-specialty notes
      let indexesToDelete: any = [];
      this.facilitySpecialtyNotes.forEach(function (note, index) {
        if (note.isNew) {
          indexesToDelete.push(index);
        }
        if (selectedFacilitySpecialtyNoteId !== note.noteId) {
          note.isViewing = false;
        }
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.facilitySpecialtyNotes.splice(indx,1);
      })
      facilitySpecialtyNote.isViewing = !facilitySpecialtyNote.isViewing;
    },
    toggleEditFacilitySpecialtyNote (facilitySpecialtyNote: any) {
      let selectedFacilitySpecialtyNoteId = facilitySpecialtyNote.noteId;
      // Collapse any editing facility-specialty notes
      // Delete any existing "new" facility-specialty notes
      let indexesToDelete: any = [];
      this.facilitySpecialtyNotes.forEach(function (note, index) {
        if (note.isNew) {
          indexesToDelete.push(index);
        }
        if (selectedFacilitySpecialtyNoteId !== note.facilitySpecialtyNoteId) {
          note.isEditing = false;
        }
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.facilitySpecialtyNotes.splice(indx,1);
      })
      facilitySpecialtyNote.isEditing = !facilitySpecialtyNote.isEditing;
    },
    cancel (facilitySpecialtyNote: any) {
      facilitySpecialtyNote.isEditing = false;
      if (facilitySpecialtyNote.isNew) {
        // Allow the editing UI to collapse before removing it from the array.
        let self = this;
        setTimeout(function () {
          self.facilitySpecialtyNotes.shift();
        }, 300);
      } else {
        this.getFacilitySpecialtyNotes();
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/facility/cards/facilitySpecialtyNotes/FacilitySpecialtyNotesCard.ts